export { createKey } from './generateTranslationKey';
